import { Navigate, useParams } from "react-router";

/** Redirect bare /events/:eventId/fleet-measurements to /yaw — the default measurement view. */
export function FleetMeasurementsIndex() {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={`/events/${eventId}/fleet-measurements/yaw`} replace />;
}
